/**
 * <amazon-click-tracker> Web Component
 *
 * Wraps Amazon buy buttons and publishes a custom Shopify analytics event
 * when clicked. The GTM custom pixel subscribes to this event.
 *
 * Usage (in Liquid):
 *   <amazon-click-tracker
 *     data-product-title="Product Name"
 *     data-product-url="/products/handle"
 *   >
 *     <a href="..." class="amazon-buy-btn" ...>Buy on Amazon</a>
 *   </amazon-click-tracker>
 */
class AmazonClickTracker extends HTMLElement {
  connectedCallback() {
    this.addEventListener('click', this.handleClick.bind(this));
  }

  handleClick(event) {
    const link = event.target.closest('.amazon-buy-btn');
    if (!link) return;

    const productTitle = this.dataset.productTitle || '';
    const productUrl = this.dataset.productUrl || '';
    const destinationUrl = link.getAttribute('href') || link.href || '';
    const buttonText = link.textContent.trim();

    // Publish to Shopify's analytics bus — the GTM pixel subscribes to this
    if (window.Shopify && window.Shopify.analytics && window.Shopify.analytics.publish) {
      window.Shopify.analytics.publish('amazon_button_click', {
        product_title: productTitle,
        product_url: productUrl,
        destination_url: destinationUrl,
        button_text: buttonText,
      });
    }
  }
}

if (!customElements.get('amazon-click-tracker')) {
  customElements.define('amazon-click-tracker', AmazonClickTracker);
}
